import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldIcon, ZapIcon, CrownIcon } from 'lucide-react';
const SOCIAL_IMG = 'https://cdn.shopify.com/s/files/1/0995/0671/6970/files/4Social_Media_Planner_Ratio16_9.jpg?v=1777847862';
const EMAIL_IMG = 'https://cdn.shopify.com/s/files/1/0995/0671/6970/files/5Email_Marketing_Kit_Ratio16_9.jpg?v=1777847795';
const DASHBOARD_IMG = 'https://cdn.shopify.com/s/files/1/0995/0671/6970/files/2Dashboard_Ratio16_9.jpg?v=1777848099';
const SILVER_URL = 'https://e1be42-id.myshopify.com/cart/51493254136106:1';
const PLATINUM_URL = 'https://e1be42-id.myshopify.com/cart/51499875991850:1';
const VIP_URL = 'https://e1be42-id.myshopify.com/cart/51499880972586:1';
const packages = [{
  id: 'silver',
  tier: 'SILVER',
  TierIcon: ShieldIcon,
  tagline: 'Starter',
  headline: 'The Essential Dashboard',
  description: 'The core system to track your real profit, manage inventory, and generate invoices. Start here and upgrade anytime.',
  price: '$59.99',
  originalPrice: '',
  savings: '$64 in bonuses FREE',
  image: DASHBOARD_IMG,
  imageAlt: 'Business Command Center Dashboard',
  ctaLabel: 'Get Silver — $59.99',
  ctaUrl: SILVER_URL,
  accentColor: '#9CA3AF',
  gradientFrom: '#4B5563',
  gradientTo: '#374151',
  glowColor: 'rgba(156,163,175,0.08)',
  borderColor: 'rgba(156,163,175,0.22)',
  ctaTextColor: '#ffffff',
  featured: false,
  featuredLabel: '',
  includes: [{
    name: 'Business Command Center Dashboard',
    value: '$59.99',
    isFree: false,
    isNew: false
  }, {
    name: 'Pricing Profit Calculator',
    value: 'FREE',
    isFree: true,
    isNew: false
  }, {
    name: '60-Day Launch Checklist PDF',
    value: 'FREE',
    isFree: true,
    isNew: false
  }]
}, {
  id: 'platinum',
  tier: 'PLATINUM',
  TierIcon: ZapIcon,
  tagline: 'Most Popular',
  headline: 'Dashboard + Content Strategy',
  description: 'Everything in Silver plus 90 days of content ready to post on Instagram, TikTok, and Facebook — from day one.',
  price: '$69.99',
  originalPrice: '$86.99',
  savings: 'Save $17',
  image: SOCIAL_IMG,
  imageAlt: 'Social Media Content Planner 90 Days',
  ctaLabel: 'Get Platinum — $69.99',
  ctaUrl: PLATINUM_URL,
  accentColor: '#FFB800',
  gradientFrom: '#FFB800',
  gradientTo: '#FF6B00',
  glowColor: 'rgba(255,184,0,0.14)',
  borderColor: 'rgba(255,184,0,0.32)',
  ctaTextColor: '#0D1A35',
  featured: true,
  featuredLabel: '✦ Most Popular',
  includes: [{
    name: 'Business Command Center Dashboard',
    value: '$59.99',
    isFree: false,
    isNew: false
  }, {
    name: 'Pricing Profit Calculator',
    value: 'FREE',
    isFree: true,
    isNew: false
  }, {
    name: '60-Day Launch Checklist PDF',
    value: 'FREE',
    isFree: true,
    isNew: false
  }, {
    name: 'Social Media Planner — 90 Days',
    value: '+$27',
    isFree: false,
    isNew: true
  }]
}, {
  id: 'vip',
  tier: 'VIP',
  TierIcon: CrownIcon,
  tagline: 'Best Value',
  headline: 'The Complete Growth System',
  description: 'The full arsenal. Dashboard, content, and email marketing working together to turn your store into a sales machine.',
  price: '$99.99',
  originalPrice: '$133.99',
  savings: 'Save $34',
  image: EMAIL_IMG,
  imageAlt: 'Email Marketing Launch Kit',
  ctaLabel: 'Get VIP — $99.99',
  ctaUrl: VIP_URL,
  accentColor: '#b4a0ff',
  gradientFrom: '#7B2FBE',
  gradientTo: '#4F46E5',
  glowColor: 'rgba(123,47,190,0.16)',
  borderColor: 'rgba(123,47,190,0.36)',
  ctaTextColor: '#ffffff',
  featured: false,
  featuredLabel: '',
  includes: [{
    name: 'Business Command Center Dashboard',
    value: '$59.99',
    isFree: false,
    isNew: false
  }, {
    name: 'Pricing Profit Calculator',
    value: 'FREE',
    isFree: true,
    isNew: false
  }, {
    name: '60-Day Launch Checklist PDF',
    value: 'FREE',
    isFree: true,
    isNew: false
  }, {
    name: 'Social Media Planner — 90 Days',
    value: '+$27',
    isFree: false,
    isNew: false
  }, {
    name: 'Email Marketing Launch Kit',
    value: '+$47',
    isFree: false,
    isNew: true
  }]
}];
export function UpgradesSection() {
  return <section id="upgrades" className="bg-[#060B18] py-24 relative overflow-hidden" data-id="element-318">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[700px] bg-purple/5 rounded-full blur-[160px] pointer-events-none" data-id="element-319" />
      <div className="absolute bottom-0 left-0 w-[500px] h-[400px] bg-[#FFB800]/4 rounded-full blur-[120px] pointer-events-none" data-id="element-320" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative" data-id="element-321">

        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-20" data-id="element-322">
          <span className="inline-block text-xs font-bold uppercase tracking-widest text-white/30 mb-4" data-id="element-323">
            Choose your package
          </span>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-white mb-5" data-id="element-324">
            Pick the Plan That{' '}
            <span style={{
            background: 'linear-gradient(135deg, #FFB800, #FF6B00)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }} data-id="element-325">
              Fits You
            </span>
          </h2>
          <p className="text-white/40 text-base max-w-xl mx-auto leading-relaxed" data-id="element-326">
            All packages include the core dashboard and both free bonuses.
            <br className="hidden sm:block" data-id="element-327" />
            Upgrade for more tools — one checkout, instant access.
          </p>
        </motion.div>

        {/* 3 package cards */}
        {/* 
          KEY FIX: No overflow-hidden on the outer card — that was clipping the badge.
          overflow-hidden is only applied to the inner image wrapper.
          The featured badge now lives ABOVE the card (outside it) via negative margin-top on the section,
          or we add top padding to featured cards and place the badge inside with proper spacing.
         */}
        <div className="grid lg:grid-cols-3 gap-6 items-start" data-id="element-328">
          {packages.map((pkg, i) => {
          const {
            TierIcon
          } = pkg;
          return <motion.div key={pkg.id} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.12,
            duration: 0.6
          }} className="relative flex flex-col rounded-3xl group transition-all duration-300 hover:-translate-y-2" style={{
            background: 'rgba(15, 26, 46, 0.92)',
            backdropFilter: 'blur(14px)',
            border: `1px solid ${pkg.borderColor}`,
            boxShadow: `0 0 60px ${pkg.glowColor}, 0 20px 50px rgba(0,0,0,0.5)`,
            // Extra top padding for featured card so badge has room
            paddingTop: pkg.featured ? '0' : '0'
          }} data-id="element-329">
                {/* 
                  BADGE — rendered as first child INSIDE the card with its own space.
                  No absolute positioning crossing card boundary = no clipping.
                 */}
                {pkg.featured ? <div className="flex justify-center pt-5 pb-0" data-id="element-330">
                    <span className="text-[11px] font-extrabold uppercase tracking-widest px-5 py-2 rounded-full whitespace-nowrap" style={{
                background: `linear-gradient(135deg, ${pkg.gradientFrom}, ${pkg.gradientTo})`,
                color: pkg.ctaTextColor,
                boxShadow: `0 4px 20px ${pkg.glowColor}`
              }} data-id="element-331">
                      {pkg.featuredLabel}
                    </span>
                  </div> : (/* Spacer so all cards start at same vertical position for content */
            <div className="pt-5" data-id="element-332" />)}

                {/* Tier header row */}
                <div className="px-7 pt-5 pb-0 flex items-center gap-3" data-id="element-333">
                  <div className="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0" style={{
                background: `${pkg.accentColor}18`,
                border: `1px solid ${pkg.accentColor}35`
              }} data-id="element-334">
                    <TierIcon className="w-5 h-5" style={{
                  color: pkg.accentColor
                }} data-id="element-335" />
                  </div>
                  <span className="font-display font-extrabold text-xl tracking-widest" style={{
                color: pkg.accentColor
              }} data-id="element-336">
                    {pkg.tier}
                  </span>
                  <span className="text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full" style={{
                background: `${pkg.accentColor}12`,
                color: pkg.accentColor,
                border: `1px solid ${pkg.accentColor}25`
              }} data-id="element-337">
                    {pkg.tagline}
                  </span>
                </div>

                {/* Headline + description */}
                <div className="px-7 pt-4 pb-6" data-id="element-338">
                  <h3 className="font-display font-extrabold text-xl text-white mb-3 leading-snug" data-id="element-339">
                    {pkg.headline}
                  </h3>
                  <p className="text-white/55 text-sm leading-relaxed" data-id="element-340">{pkg.description}</p>
                </div>

                {/* Image — overflow-hidden ONLY here, not on the card */}
                <div className="mx-5 rounded-2xl overflow-hidden relative" style={{
              aspectRatio: '16/9'
            }} data-id="element-341">
                  <img src={pkg.image} alt={pkg.imageAlt} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" data-id="element-342" />
                  <div className="absolute inset-0" style={{
                background: `linear-gradient(135deg, ${pkg.gradientFrom}14 0%, transparent 60%, ${pkg.gradientTo}0a 100%)`
              }} data-id="element-343" />
                  {/* Price chip */}
                  <div className="absolute bottom-3 right-3 rounded-xl px-3 py-2 backdrop-blur-md text-right" style={{
                background: 'rgba(6,11,24,0.80)',
                border: `1px solid ${pkg.accentColor}28`
              }} data-id="element-344">
                    {pkg.originalPrice && <p className="text-white/35 text-[10px] line-through leading-tight" data-id="element-345">{pkg.originalPrice}</p>}
                    <p className="font-display font-extrabold text-xl leading-tight" style={{
                  color: pkg.accentColor
                }} data-id="element-346">
                      {pkg.price}
                    </p>
                  </div>
                  {/* Savings chip */}
                  <div className="absolute top-3 left-3 text-[10px] font-bold px-3 py-1.5 rounded-full backdrop-blur-sm" style={{
                background: `${pkg.accentColor}18`,
                color: pkg.accentColor,
                border: `1px solid ${pkg.accentColor}35`
              }} data-id="element-347">
                    {pkg.savings}
                  </div>
                </div>

                {/* Includes list */}
                <div className="px-7 pt-6 pb-2 flex-1" data-id="element-348">
                  <p className="text-[10px] font-bold uppercase tracking-widest text-white/25 mb-4" data-id="element-349">
                    Included in this package
                  </p>
                  <ul className="space-y-2.5" data-id="element-350">
                    {pkg.includes.map(item => <li key={item.name} className="flex items-center justify-between gap-3 rounded-xl px-3 py-2.5" style={item.isNew ? {
                  background: `${pkg.accentColor}10`,
                  border: `1px solid ${pkg.accentColor}22`
                } : {
                  background: 'rgba(255,255,255,0.03)'
                }} data-id="element-351">
                        <div className="flex items-center gap-2.5" data-id="element-352">
                          <span className="w-4 h-4 rounded-full flex items-center justify-center flex-shrink-0" style={{
                      background: item.isNew ? `${pkg.accentColor}22` : 'rgba(0,201,177,0.15)'
                    }} data-id="element-353">
                            <CheckIcon className="w-2.5 h-2.5" style={{
                        color: item.isNew ? pkg.accentColor : '#00C9B1'
                      }} data-id="element-354" />
                          </span>
                          <span className="text-sm leading-snug" style={{
                      color: item.isNew ? 'rgba(255,255,255,0.92)' : 'rgba(255,255,255,0.6)',
                      fontWeight: item.isNew ? 600 : 400
                    }} data-id="element-355">
                            {item.name}
                          </span>
                        </div>
                        <span className="text-xs font-semibold flex-shrink-0 ml-2" style={{
                    color: item.isFree ? '#00C9B1' : item.isNew ? pkg.accentColor : 'rgba(255,255,255,0.28)'
                  }} data-id="element-356">
                          {item.value}
                        </span>
                      </li>)}
                  </ul>
                </div>

                {/* CTA button */}
                <div className="px-7 pt-6 pb-7" data-id="element-357">
                  <a href={pkg.ctaUrl} className="block w-full text-center font-display font-extrabold text-base py-4 rounded-2xl transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl" style={{
                background: `linear-gradient(135deg, ${pkg.gradientFrom}, ${pkg.gradientTo})`,
                color: pkg.ctaTextColor,
                boxShadow: `0 6px 24px ${pkg.glowColor}`
              }} data-id="element-358">
                    {pkg.ctaLabel} →
                  </a>
                  <p className="text-center text-white/22 text-xs mt-3" data-id="element-359">
                    One-time payment · Instant download · Lifetime access
                  </p>
                </div>
              </motion.div>;
        })}
        </div>

        {/* Base option nudge */}
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="text-center text-white/22 text-sm mt-12" data-id="element-360">
          Not sure which to pick?{' '}
          <button onClick={() => document.querySelector('#product')?.scrollIntoView({
          behavior: 'smooth'
        })} className="text-teal underline underline-offset-2 hover:text-teal/70 transition-colors" data-id="element-361">
            See what's inside the dashboard first ↑
          </button>
        </motion.p>
      </div>
    </section>;
}